<template>
  <div class="p-4">
    <!--dashboard main body start-->
    <div class="dashboard-body dashboard-invoice">
      <div class="dashboard-body-content d-flex align-items-start flex-column">
        <div class="page-global-header px-0">
          <div class="mx-0">
            <form class="base-form">
              <div class="row d-flex align-items-center justify-content-between flex-row px-2">
                <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3">
                  <div class="input-group input-group--3d p-0">
                    <div class="input-group-text default client-icon-wide">
                      <img src="@/assets/images/system/add-user-blue.png" />
                      <sup><span class="text-danger">*</span></sup>
                    </div>
                    <input type="text" name="itemTitle" class="form-control client-input"
                      placeholder="Add or search a client" v-model="clientName"
                      @click="getClientData(); showAddClientForm = false;" data-bs-target="#getClient"
                      data-bs-toggle="modal" autocomplete="off" />
                    <div class="input-group-text transparent p-0 append flush-before">
                      <button type="button" name="btn" class="btn btn-white _sm">
                        <i class="fa fa-search" data-bs-target="#getClient" data-bs-toggle="modal"
                          @click="getClientData(); showAddClientForm = false;"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-9 col-xl-9 col-xxl-9">
                  <div class="row d-flex align-items-center justify-content-end">
                    <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-4">
                      <div class="input-group input-group-sm p-0">
                        <span class="input-group-text flush-after">
                          Date <sup><span class="text-danger">*</span></sup></span>
                        <input type="date" name="Invoice_date"
                          class="form-control datepicker text-end text-black _3d-input chevron-circle"
                          v-model="invoice_date" onfocus="this.showPicker()" data-date-format="mm/dd/yyyy" />
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3">
                      <div class="input-group input-group-sm p-0">
                        <span class="input-group-text flush-after">
                          Terms <sup><span class="text-danger">*</span></sup></span>
                        <select name="paymenetMethod" v-model="terms" class="form-select form-select-sm" required>
                          <option v-for="day in 32" :key="day" :value="day - 1">
                            {{ day - 1 }} Days
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-auto">
                      <button class="btn btn-white" type="button" style="cursor: default;">
                        Invoice No: {{ invoiceNumber }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="w-100 my-3 px-2">
          <div class="white-shadebox">
            <ul class="nav nav-fill nav--iconicshade">
              <li class="nav-item">
                <a href="#" class="nav-link" data-bs-target="#addItemToList" data-bs-toggle="modal">
                  <span class="nav-icon shade">
                    <img src="@/assets/images/system/plus-orange.png" /></span>
                  <span class="nav-text">Add Item</span>
                </a>
              </li>
              <li class="nav-item">
                <a href="#" class="nav-link" data-bs-target="#addPayment" data-bs-toggle="modal">
                  <span class="nav-icon shade"><img src="@/assets/images/system/dollar.png" /></span>
                  <span class="nav-text">Payment</span>
                </a>
              </li>
              <li class="nav-item">
                <a href="#" class="nav-link" data-bs-target="#addDiscount" data-bs-toggle="modal">
                  <span class="nav-icon shade">
                    <img src="@/assets/images/system/percent-orange.png" />
                  </span>
                  <span class="nav-text">Discount</span>
                </a>
              </li>
              <li class="nav-item">
                <a href="#" class="nav-link" data-bs-target="#addAttachment" data-bs-toggle="modal">
                  <span class="nav-icon shade"><img src="@/assets/images/system/camera-blues.png" />
                    <span class="has-badge" v-if="image_count > 0">{{
                      image_count
                    }}</span>
                  </span>
                  <span class="nav-text">Attachment</span>
                </a>
              </li>
              <li class="nav-item">
                <a href="#" class="nav-link" data-bs-target="#addNote" data-bs-toggle="modal">
                  <span class="nav-icon shade"><img src="@/assets/images/system/edit-orange.png" />
                    <span class="has-badge" v-if="note != ''"><i class="fa fa-check"></i></span>
                  </span>
                  <span class="nav-text">Note</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="page-body">
          <div class="row has-vr-devider position-relative mt-5 mx-0">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-5 col-xxl-5">
              <div class="contact-card-group">
                <!--repeatable block-->
                <div class="card card-flex-row _v2" v-for="(item, itemIndex) in itemPaginatedList" :key="itemIndex">
                  <div class="card-header">
                    <span class="badge-count">{{ itemIndex + 1 }}</span>
                  </div>
                  <div class="card-body">
                    <ul class="cmn-vrList">
                      <li class="list-title">{{ item.category_type }}</li>
                      <li class="sub-title">{{ item.name }}</li>
                      <li class="mt-2">{{ item.description }}</li>
                      <li class="price-tag">
                        {{ parseInt(item.quantity) }} x
                        {{ parseFloat(item.unit_price).toFixed(2) }}
                      </li>
                    </ul>
                  </div>
                  <div class="card-footer justify-content-between flex-column align-items-end">
                    <ul class="hr-navList">
                      <li class="nav-item ellipsis-dropdown dropdown">
                        <a href="#" class="nav-link dropdown-toggle no-caret" id="edit-act-1" data-bs-toggle="dropdown"
                          aria-expanded="false"><i class="fas fa-ellipsis-v"></i></a>
                        <ul class="dropdown-menu" aria-labelledby="edit-act-1">
                          <li>
                            <a class="dropdown-item delete" href="#" @click="removeItem(item.item_no)"><i
                                class="fa fa-times"></i>
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <div class="ftr-price-tag text-secondary">
                      <span v-if="item.type === 'parts'">
                        <i class="fas fa-cog"></i>
                      </span>
                      <span v-else>
                        <i class="fas fa-running"></i>
                      </span>
                    </div>
                    <div class="ftr-price-tag">
                      {{ currency_symbol
                      }}{{
                        parseFloat(
                          parseInt(item.quantity) * parseFloat(item.unit_price)
                        ).toFixed(2)
                      }}
                    </div>
                  </div>
                </div>

                <!-- Pagination -->
                <div class="mt-4">
                  <el-pagination background layout="prev, pager, next" :pager-count="5" :total="selectedItemsList.length"
                    :page-size="itemPageSize" :current-page="itemCurrentPage" @current-change="itemHandlePageChange" />
                </div>
                <!--ended repeatable block-->
              </div>
            </div>

            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-5 col-xxl-5 ms-auto">
              <form class="base-form ps-xl-5">
                <div class="row m-0 mb-3 pe-xl-5">
                  <div class="input-group _group-xl flush-shadow p-0">
                    <span class="input-group-text justify-content-end flush-after label-w-fixed">
                      Amount
                    </span>
                    <input type="text" name="amount" class="form-control" v-model="totalPrice" disabled />
                  </div>
                </div>

                <!-- <div class="row m-0 mb-3 pe-xl-5" v-if="discount > 0"> -->
                <div class="row m-0 mb-3 pe-xl-5">
                  <div class="input-group _group-xl flush-shadow p-0">
                    <span class="input-group-text justify-content-end flush-after label-w-fixed">
                      Discount ({{ isPercentChecked ? "%" : currency_symbol }})
                    </span>
                    <input type="text" name="amount" class="form-control" v-model="discountTypeValue" disabled />
                  </div>
                </div>

                <div class="row m-0 mb-3 pe-xl-5">
                  <div class="input-group _group-xl flush-shadow p-0">
                    <span class="input-group-text justify-content-end flush-after label-w-fixed">
                      Sub-Total
                    </span>
                    <input type="text" name="amount" class="form-control" v-model="subTotalPrice" disabled />
                  </div>
                </div>

                <div class="row m-0 mb-3 pe-xl-5" v-if="tax_1_status_enable">
                  <!-- <div class="row m-0 mb-3 pe-xl-5"> -->
                  <div class="input-group _group-xl flush-shadow p-0">
                    <span class="input-group-text justify-content-end flush-after label-w-fixed">
                      Tax (Vat) ({{ tax_1_rate }}%)
                    </span>
                    <input type="text" name="amount" class="form-control" v-model="vatTax" />
                  </div>
                </div>

                <div class="row m-0 mb-3 pe-xl-5" v-if="tax_2_status_enable">
                  <!-- <div class="row m-0 mb-3 pe-xl-5"> -->
                  <div class="input-group _group-xl flush-shadow p-0">
                    <span class="input-group-text justify-content-end flush-after label-w-fixed">
                      Tax 2 ({{ tax_2_rate }}%)
                    </span>
                    <input type="text" name="amount" class="form-control" v-model="vatTax2" />
                  </div>
                </div>

                <div class="row m-0 mb-3 pe-xl-5">
                  <!-- <div class="row m-0 mb-3 pe-xl-5"> -->
                  <div class="input-group _group-xl flush-shadow p-0">
                    <span class="input-group-text justify-content-end flush-after label-w-fixed">
                      Total
                    </span>
                    <input type="text" name="total_amount" class="form-control" v-model="GrandTotal" />
                  </div>
                </div>

                <div class="row m-0 mb-3 pe-xl-5">
                  <div class="input-group _group-xl flush-shadow p-0">
                    <span class="input-group-text justify-content-end flush-after label-w-fixed">
                      Payments
                    </span>
                    <input type="text" name="amount" class="form-control" :value="totalSubmittedAmount" disabled />
                  </div>
                </div>

                <div class="row m-0 mb-3 pe-xl-5">
                  <div class="input-group _group-xl flush-shadow p-0">
                    <span class="input-group-text justify-content-end flush-after label-w-fixed">
                      Outstanding Due
                    </span>
                    <div class="form-floating">
                      <label class="floating-label highlight">{{
                        currency_symbol
                      }}</label>
                      <input type="text" name="amount" class="form-control highlight" v-model="outstanding_due"
                        disabled />
                    </div>
                  </div>
                </div>

                <div class="row m-0 mb-3 pe-xl-5 mt-5 d-flex justify-content-end">
                  <div class="col-sm-12 p-0 d-flex align-items-center justify-content-end">
                    <button type="button" class="btn btn-offWhite">Cancel</button>
                    <button type="button" class="btn btn-success btn-shadow ms-5" @click="saveInvoice">
                      Next
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--dashboard main body end-->

    <!--add browse Modal for client-->
    <div class="modal fade mdl-messaging _info" id="getClient" aria-hidden="true" aria-labelledby="getClientLabel"
      tabindex="-1">
      <div class="modal-dialog" style="max-width: 560px">
        <div class="modal-dialog-header">
          <div class="header-title">Client</div>
        </div>
        <div class="modal-content">
          <div class="addressbook-popup">
            <!-- Search & Actions -->
            <div class="page-global-header px-0 mb-3 w-100">
              <div class="d-flex align-items-center gap-2">
                <div class="global-searchbar" style="flex: 1; min-width: 0;">
                  <form class="base-form" @submit.prevent="filterClients">
                    <div class="input-group">
                      <div class="input-group-text">
                        <img src="@/assets/images/system/groups.svg" style="width: 14px;" />
                      </div>
                      <input type="search" v-model="searchQuery" @input="filterClients" class="form-control"
                        placeholder="(Company name, Client name, Email etc)" />
                      <button type="submit" class="btn btn-primary">
                        <i class="fa fa-search" style="font-size: 1rem;"></i>
                      </button>
                    </div>
                  </form>
                </div>
                <ul class="search-option-menu m-0 p-0">
                  <li class="nav-item sorting">
                    <input type="checkbox" class="sorting-check" id="btn-sorting-modal" autocomplete="off"
                      @change="toggleSort" :checked="sortDir === 'desc'" />
                    <label class="btn btn-sorting" for="btn-sorting-modal"><span class="sr-only">Sort</span></label>
                  </li>
                  <li class="nav-item ms-2">
                    <button type="button" data-bs-target="#addClientModal" data-bs-toggle="modal" class="nav-link circleNav">
                      <i class="fa fa-plus"></i>
                    </button>
                  </li>
                </ul>
              </div>
            </div>

            <!-- List -->
            <div class="ab-list">
              <div v-if="!displayedClients.length" class="empty">
                No clients found. Try a different search.
              </div>
              <div v-else class="contact-card" v-for="(clientID, index) in displayedClients" :key="index"
                @click="selectClient(clientID)" :class="{ 'border-success': clientExists(clientID) }">
                <div class="contact-avatar">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z" />
                    <path d="M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8" />
                  </svg>
                </div>
                <div class="contact-body">
                  <div v-if="clientID.full_name" class="contact-line company">
                    <span class="num">{{ (clientCurrentPage - 1) * clientPageSize + index + 1 }}.</span>
                    <span class="tag">N:</span> {{ clientID.full_name }}
                  </div>
                  <div class="contact-line" :class="{ company: !clientID.full_name }">
                    <span v-if="!clientID.full_name" class="num">{{ (clientCurrentPage - 1) * clientPageSize + index + 1
                    }}.</span>
                    <span class="tag muted-tag">Co:</span> {{ clientID.business_name }}
                  </div>
                  <div v-if="clientID.phone1" class="contact-line">
                    <span class="tag muted-tag">T:</span> {{ clientID.phone1 }}
                  </div>
                  <div v-if="clientID.email" class="contact-line email">
                    <span class="tag">E:</span> <a :href="'mailto:' + clientID.email" @click.stop>{{ clientID.email
                    }}</a>
                  </div>
                  <div class="kebab-wrap" @click.stop>
                    <button class="kebab-btn" type="button" title="More options" aria-label="More options"
                      @click="toggleKebab(clientID.id || index)">
                      <span></span><span></span><span></span>
                    </button>
                    <div class="kebab-menu" :class="{ open: openKebabId === (clientID.id || index) }">
                      <button type="button" @click="editClient(clientID.id)">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                        </svg>
                        Edit
                      </button>
                      <button type="button" class="delete" @click="deleteClient(clientID.id)">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <polyline points="3 6 5 6 21 6" />
                          <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                          <path d="M10 11v6" />
                          <path d="M14 11v6" />
                          <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                        </svg>
                        Delete
                      </button>
                    </div>
                  </div>
                  <div class="card-actions" @click.stop v-if="clientID.notes && clientID.notes !== 'N/A'">
                    <button type="button" class="note-btn" :title="clientID.notes">
                      <i class="far fa-file-alt"></i> Note
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Footer -->
            <div class="ab-footer">
              <div class="pagination">
                <el-pagination background layout="prev, pager, next" :pager-count="5" :total="filteredClients.length"
                  :page-size="clientPageSize" :current-page="clientCurrentPage"
                  @current-change="clientHandlePageChange" />
              </div>
              <button type="button" class="close-btn" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Standalone Add Client Modal -->
    <AddClientInline @client-created="onClientCreated" />

    <!--add browse Modal file for item; create-->
    <div class="modal fade mdl-messaging _info" id="addItemToList" data-bs-focus="false" aria-hidden="true"
      aria-labelledby="addItemToListLabel">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header d-flex justify-content-between align-items-center border-0 p-0">
            <button class="btn btn-lauren-green btn-sm position-absolute"
              style="top: -3.5rem; left: 0rem; z-index: 1051; border: 2px solid white;">
              <i class="fas fa-tools me-2"></i> Add Item
            </button>
            <button type="button" class="btn-close position-absolute" style="top: 1rem; right: 1rem; z-index: 1051;"
              data-bs-dismiss="modal" aria-label="Close">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <AddItem from-view="add_invoice" @show-list-of-items="showItemListPopup" @closeItemsPopup="closeItem">
          </AddItem>
        </div>
      </div>
    </div>

    <!--add brows Modal file for item list-->
    <el-dialog v-model="dialogVisibleItemsPopup" title="Item List" width="40%" :before-close="handleCloseAddItem"
      append-to-body destroy-on-close class="item-list-dialog">
      <div class="clearfix"></div>
      <ItemListOnlyInvoice ref="itemListOnlyComponent" :popupOpenEvent="dialogVisibleItemsPopup"></ItemListOnlyInvoice>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisibleItemsPopup = false">Close</el-button>
        </span>
      </template>
    </el-dialog>

    <!--add discount-->
    <div class="modal fade mdl-messaging" id="addDiscount" aria-hidden="true" aria-labelledby="addDiscountLabel"
      tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-dialog-header">
          <div class="header-title">Discount</div>
        </div>
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body p-4">
            <div class="message-card align-items-center justify-content-center p-4">
              <form class="form-v2 d-flex flex-column justify-content-around w-100">
                <div class="row d-flex flex-row justify-content-between px-3 m-0 mb-4">
                  <div class="form-check _embossed _tabed col-5 p-0">
                    <input class="form-check-input input-radio" type="radio" name="discType" id="rdo-percent"
                      :checked="isPercentChecked" @change="handleCheckboxChange('percent')">
                    <label class="form-check-label w-100 text-center" for="rdo-percent">
                      Percent (%)
                    </label>
                  </div>

                  <div class="form-check _embossed _tabed col-5 p-0">
                    <input class="form-check-input input-radio" type="radio" name="discType" id="rdo-cash"
                      :checked="isCashChecked" @change="handleCheckboxChange('cash')">
                    <label class="form-check-label w-100 text-center" for="rdo-cash">
                      Amount
                    </label>
                  </div>
                </div>
                <!-- Retain the el-input-number logic from existing codebase -->
                <div class="row m-0">
                  <div class="input-group group-half p-0"
                    style="border: 1px solid #ced4da; border-radius: 8px; overflow: hidden;">
                    <div class="input-group-text bg-javaBlue prepend no-after"
                      style="border: none; border-radius: 0; color: white; font-weight: 600;">Discount</div>
                    <div class="flex-grow-1 d-flex align-items-center bg-white px-3">
                      <el-input-number v-model="discount" :min="0" :max="isPercentChecked ? 100 : 1000000"
                        class="flex-grow-1 custom-number-input" :controls="false" placeholder="0.00"
                        style="width: 100%;" />
                      <span class="ms-2"
                        style="font-weight: bold; font-size: 1.1rem; color: #333; min-width: 20px; text-align: center;">
                        {{ isPercentChecked ? '%' : currency_symbol }}
                      </span>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer m-2 p-0">
            <button type="button" class="btn btn-success btn-shadow ms-auto" data-bs-dismiss="modal">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--add attachment-->
    <div class="modal fade mdl-messaging _info" id="addAttachment" aria-hidden="true"
      aria-labelledby="addAttachmentLabel" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-dialog-header">
          <div class="header-title">
            Attachment
          </div>
        </div>
        <div class="modal-content">
          <div class="modal-header">

            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"><i
                class="fa fa-times"></i></button>
          </div>
          <div class="modal-body p-4">

            <div class="card-attachment">
              <div class="file-input-wrapper">
                <form class="base-form">
                  <input type="file" name="fileUpload" class="file-input" accept="image/jpeg, image/png"
                    @change="onFileChange" multiple="multiple" />
                  <div class="file-content">
                    <div class="file-icons">
                      <i class="fa fa-cloud-upload-alt"></i>
                    </div>
                    <div class="file-info-text">Drag & Drop <span class="stamp">files here or</span> <span
                        class="active">upload here</span></div>
                  </div>
                </form>
              </div>
              <div class="col-sm-12 d-flex align-items-center justify-content-center mt-2">
                <small>Note: Size: 512kb, png or jpeg only.</small>
              </div>

              <div class="upload-preview-thumb mt-4" v-if="image_list.length > 0">
                <!-- New thumbnails UI for uploaded preview -->
                <div class="thumb-item" v-for="(image, index) in image_list" :key="index">
                  <a href="javascript:;" class="thumb-image"> <img :src="image.url" :alt="`Preview ${index + 1}`" /></a>
                  <span class="badge-count">{{ index + 1 }}</span>
                  <button type="button" class="btn-delete-thumb" @click="removeNewImage(index)">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>

            </div>

          </div>

          <div class="modal-footer m-2 p-0">
            <button type="button" name="button" class="btn btn-success btn-shadow ms-auto"
              data-bs-dismiss="modal">Save</button>
          </div>

        </div>
      </div>
    </div>

    <!--add note-->
    <div class="modal fade mdl-messaging _info" id="addNote" aria-hidden="true" aria-labelledby="addNoteLabel"
      tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-dialog-header">
          <div class="header-title">
            Note
          </div>
        </div>
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"><i
                class="fa fa-times"></i></button>
          </div>
          <div class="modal-body p-4">

            <div class="message-card align-items-center justify-content-center p-4 w-100">
              <button type="button" name="button" class="btn-deleteCard" @click="note = ''"><i
                  class="fa fa-trash-alt"></i></button>
              <el-input v-model="note" :rows="6" type="textarea" placeholder="Please input note..."
                class="w-100 mt-2" />
            </div>
          </div>

          <div class="modal-footer m-2 p-0">
            <button type="button" name="button" class="btn btn-success btn-shadow ms-auto"
              data-bs-dismiss="modal">Save</button>
          </div>

        </div>
      </div>
    </div>

    <!--add payment-->
    <div class="modal fade mdl-messaging _info" id="addPayment" aria-hidden="true" aria-labelledby="addPaymentLabel"
      tabindex="-1">
      <div class="modal-dialog" style="max-width: 70rem">
        <div class="modal-dialog-header">
          <div class="header-title">Payment</div>
        </div>
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div class="page-body mb-4">
            <div class="row mt-3 mx-0">
              <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 mx-auto">
                <div class="card card-general h-100">
                  <div class="card-body">
                    <form class="form-v2 h-100 d-flex flex-column justify-content-between">
                      <div class="w-100">
                        <div class="row m-0 mb-3">
                          <div class="input-group _group-xl p-0">
                            <span class="input-group-text bg-bostonBlue flush-after text-start label-w-fixed">
                              Payment Method
                              <sup><span class="text-danger">*</span></sup>
                            </span>
                            <select name="payment_method" v-model="payment_method" class="form-select" required>
                              <option value="" selected disabled>Please Select</option>
                              <option v-for="item in payment_method_list" :key="item" :value="item">
                                {{ item }}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="row m-0 mb-3">
                          <div class="input-group _group-xl p-0">
                            <span class="input-group-text flush-after text-start label-w-fixed">
                              Payment Date <sup><span class="text-danger">*</span></sup>
                            </span>
                            <input type="date" name="payment_date" v-model="payment_date" onfocus="this.showPicker()"
                              class="form-control datepicker text-end text-black _3d-input chevron-circle"
                              data-date-format="mm/dd/yyyy" />
                          </div>
                        </div>
                      </div>

                      <div class="w-100">
                        <div class="row m-0 mb-3 d-flex justify-content-end">
                          <div class="col-sm-9">
                            <div class="row mb-3">
                              <div class="input-group group-half p-0">
                                <div class="input-group-text bg-light-orange no-after label-w-fixed">
                                  Total Amount
                                </div>
                                <div class="form-floating">
                                  <label class="floating-label _currency">{{
                                    currency_symbol
                                  }}</label>
                                  <input type="text" class="form-control text-right" placeholder="1"
                                    :value="GrandTotal" />
                                </div>
                              </div>
                            </div>

                            <div class="row mb-3">
                              <div class="input-group group-half p-0">
                                <div class="input-group-text bg-light-sky no-after label-w-fixed">
                                  Outstanding Due
                                </div>
                                <div class="form-floating">
                                  <label class="floating-label _currency">{{
                                    currency_symbol
                                  }}</label>
                                  <input type="text" name="due" placeholder="Due Amount" class="form-control text-right"
                                    v-model="outstanding_due" disabled />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="w-100">
                        <div class="row m-0 mb-3 d-flex justify-content-end">
                          <div class="col-sm-9">
                            <div class="row">
                              <div class="input-group group-half p-0">
                                <div class="input-group-text bg-success no-after label-w-fixed">
                                  Pay Now <sup><span class="text-danger">*</span></sup>
                                </div>
                                <div class="form-floating">
                                  <label class="floating-label _currency">{{
                                    currency_symbol
                                  }}</label>
                                  <input type="text" name="pay_now_amount" placeholder="Pay now"
                                    class="form-control text-right" v-model="pay_now_amount" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row m-0 mb-3">
                          <div class="input-group _group-xl h-auto p-0">
                            <textarea class="form-control textarea-lg no-resize" placeholder="Notes..."
                              name="pay_now_description" v-model="pay_now_description"></textarea>
                          </div>
                          <span class="form-text text-end text-stamp">Max 255 character</span>
                        </div>

                        <div class="row m-0">
                          <div class="form-check outliner">
                            <el-checkbox v-model="mark_fully_paid" @change="fullyPaidToggle" label="Mark as Fully Paid"
                              :checked="false">
                            </el-checkbox>
                          </div>
                        </div>
                        <div class="text-end">
                          <button type="button" class="btn btn-success btn-shadow ms-5" @click="addPayment">
                            Add
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 mx-auto">
                <div class="card card-general h-100">
                  <div class="card-body">
                    <form class="form-v2">
                      <div class="row m-0 mb-3">
                        <div class="contact-card-group">
                          <!--repeatable block-->
                          <div class="card card-flex-row _v3" v-for="(paymnt, index) in payment" :key="index">
                            <div class="card-header">
                              <span class="badge-count">{{ index + 1 }}</span>
                            </div>
                            <div class="card-body">
                              <div class="card-content">
                                <ul class="label-list">
                                  <li class="sub-title">PM: {{ paymnt.method }}</li>
                                  <li class="text-danger">
                                    PD: {{ paymnt.submission_date }}
                                  </li>
                                </ul>
                              </div>

                              <div class="content-option w-auto">
                                <div class="row m-0 h-100 justify-content-end flex-column">
                                  <ul class="card-action-nav h-auto flex-row flex-nowrap">
                                    <li class="nav-item" v-if="paymnt.description != ''">
                                      <a href="#" class="btn btn-info btn-sm"><i class="fa fa-edit"></i> Note
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div class="card-footer justify-content-between flex-column align-items-end">
                              <div class="footer-list-wraper justify-content-end">
                                <ul class="footer-list _big">
                                  <li>Paid</li>
                                  <li class="count">
                                    {{ currency_symbol }}{{ paymnt.submitted_amount }}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <!--ended repeatable block-->
                        </div>
                      </div>

                      <div class="row m-0 mb-3 d-flex justify-content-end">
                        <div class="col-sm-9">
                          <div class="input-group group-half p-0">
                            <div class="input-group-text bg-orange no-after">
                              Total Amount
                            </div>
                            <div class="form-floating">
                              <label class="floating-label _currency">{{ currency_symbol }}</label>
                              <input type="text" class="form-control text-right" placeholder="1" disabled="true"
                                :value="totalSubmittedAmount" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="text-end mt-3">
                    <button class="btn btn-success" data-bs-dismiss="modal" aria-label="Close">
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Modal } from "bootstrap";

import { CURRENCY_LIST } from "../../config/url";
import AddItem from "@/components/invoice/AddItem.vue";
import ItemListOnlyInvoice from "@/components/items/ItemListOnly.vue";

import AddClientInline from "@/components/clients/AddClientInline.vue";

export default {
  name: "AddInvoice",
  props: {
    title: String,
    // rest of the blog post props
  },
  components: {
    AddClientInline,
    AddItem,
    ItemListOnlyInvoice,
  },
  data() {
    const today = new Date();
    const formattedToday = today.toISOString().split("T")[0];
    return {
      showAddClientForm: false,
      openKebabId: null,
      show_total_expense: 0,
      invoice_server_data: [],
      dialogVisibleItemsPopup: false,
      isPercentChecked: true,
      isCashChecked: false,
      image_count: 0,
      searchQuery: "",
      filteredClients: [],
      // needed in form
      invoice_date: formattedToday,
      terms: 28,
      invoiceNumber: 0,
      totalPrice: parseFloat(0.0).toFixed(2),
      subTotalPrice: parseFloat(0.0).toFixed(2),
      client_server_data: [],
      client: "",
      clientName: "",
      tax_1_rate: 0,
      tax_1_name: "",
      tax_2_name: "",
      tax_vat_amount: 0,
      tax_1_status_enable: false,
      tax_2_status_enable: false,
      tax_2_rate: 0,
      tax_2_amount: 0,
      discountTypeValue: 0,
      discountType: "",
      discount: 0,
      image_list: [],
      is_image: "N",
      note: "",
      payment_method_list: "",
      payment_method: "",
      payment_date: formattedToday,
      outstanding_due: parseFloat(0.0).toFixed(2),
      pay_now_amount: "",
      pay_now_description: "",
      payment: [],
      currency_symbol: this.$auth.user?.currency,
      currency_id: this.$store.state.auth.user.currency_id,
      invoice_status: "draft",
      invoice_type: "draft",
      GrandTotal: parseFloat(0.0).toFixed(2),
      clientCurrentPage: 1, // Current page number
      clientPageSize: 4, // Number of items per page
      itemCurrentPage: 1, // Current pagination page
      itemPageSize: 4, // Items per page
      mark_fully_paid: false,
      sortDir: "asc",
    };
  },
  created() {
    this.runMountedFunctions();
  },
  watch: {
    searchQuery() {
      this.clientCurrentPage = 1; // Reset to first page on search
      this.filterClients();
    },
    client_server_data() {
      this.filterClients();
    },
    dialogVisibleItemsPopup(newValue) {
      if (!newValue) {
        // Close the Bootstrap modal if Element UI dialog is closed
        const bootstrapModal = document.getElementById("addItemToList");
        if (bootstrapModal) {
          const bsModalInstance = Modal.getInstance(bootstrapModal);
          if (bsModalInstance) {
            bsModalInstance.hide();
          }
        }
      }
    },
    totalPriceCalculation() {
      this.totalPrice = parseFloat(this.totalPriceCalculation).toFixed(2);
    },
    discount(newVal) {
      console.log("Discount changed to:", newVal);
    },
    subtotalCalculation() {
      this.subTotalPrice = parseFloat(this.subtotalCalculation).toFixed(2);
      let tax1Amount = 0;
      let tax2Amount = 0;

      if (this.tax_1_rate > 0) {
        tax1Amount = parseFloat((this.subTotalPrice * this.tax_1_rate) / 100).toFixed(2);
      }

      if (this.tax_2_rate > 0) {
        tax2Amount = parseFloat((this.subTotalPrice * this.tax_2_rate) / 100).toFixed(2);
      }

      let paymentTotal = 0;
      if (this.payment.length > 0) {
        paymentTotal = this.payment
          .reduce((total, pmt) => total + parseFloat(pmt.submitted_amount), 0)
          .toFixed(2);
      }

      this.GrandTotal = parseFloat(
        parseFloat(this.subTotalPrice) + parseFloat(tax1Amount) + parseFloat(tax2Amount)
      ).toFixed(2);
      this.outstanding_due = parseFloat(this.GrandTotal - paymentTotal).toFixed(2);
    },
  },
  computed: {
    pageTitle() {
      return (document.title = `${this.title.replace(/\b\w/g, (match) =>
        match.toUpperCase()
      )} | Smoothbalance`);
    },
    itemPaginatedList() {
      const start = (this.itemCurrentPage - 1) * this.itemPageSize;
      const end = start + this.itemPageSize;
      return this.selectedItemsList.slice(start, end);
    },
    selectedItemsList() {
      let selectedItems = this.$store.getters["item/getSelectedItemsList"];
      return selectedItems;
    },
    clientPaginatedData() {
      const start = (this.clientCurrentPage - 1) * this.clientPageSize;
      const end = start + this.clientPageSize;
      return this.client_server_data.slice(start, end);
    },
    totalSubmittedAmount() {
      if (this.payment.length > 0) {
        const total = this.payment.reduce((sum, pmt) => {
          const amount = parseFloat(pmt.submitted_amount);
          return sum + (isNaN(amount) ? 0 : amount);
        }, 0);
        return parseFloat(total).toFixed(2);
      }
      return "0.00";
    },
    totalPriceCalculation() {
      // Get the selected items from the store
      let selectedItems = this.$store.getters["item/getSelectedItemsList"];

      // Ensure it's always an array
      if (!Array.isArray(selectedItems)) {
        selectedItems = [];
      }

      // Safely calculate total
      const total = selectedItems.reduce((total, item) => {
        const qty = parseInt(item.quantity) || 0;
        const price = parseFloat(item.unit_price) || 0;
        return total + qty * price;
      }, 0);

      return parseFloat(total).toFixed(2); // Ensure 2 decimals
    },

    subtotalCalculation() {
      const total = parseFloat(this.totalPriceCalculation); // use this.totalPriceCalculation instead of total_price

      let discountedTotal = 0;
      if (this.isPercentChecked) {
        discountedTotal = total - (total * this.discount) / 100;
        this.discountTypeValue = ((total * this.discount) / 100).toFixed(2);
        this.discountType = "percent";
      } else {
        discountedTotal = total - this.discount;
        this.discountTypeValue = parseFloat(this.discount).toFixed(2);
        this.discountType = "amount";
      }

      return discountedTotal.toFixed(2);
    },

    currencyOptions() {
      if (this.currency) {
        return this.currency.map((v) => {
          return {
            id: v.id,
            name: v.name,
            symbol: v.symbol,
          };
        });
      }
      return [];
    },
    vatTax() {
      return (
        (parseFloat(this.subTotalPrice) * parseFloat(this.tax_1_rate)) /
        100
      ).toFixed(2);
    },
    vatTax2() {
      return (
        (parseFloat(this.subTotalPrice) * parseFloat(this.tax_2_rate)) /
        100
      ).toFixed(2);
    },
    displayedClients() {
      const startIndex = (this.clientCurrentPage - 1) * this.clientPageSize;
      const endIndex = startIndex + this.clientPageSize;
      return this.filteredClients.slice(startIndex, endIndex);
    },
  },
  methods: {
    closeModal() {
      const bootstrapModal = document.getElementById("getClient");
      if (bootstrapModal) {
        const bsModalInstance = Modal.getInstance(bootstrapModal);
        if (bsModalInstance) {
          bsModalInstance.hide();
        }
      }
    },
    editClient(id) {
      this.openKebabId = null;
      this.closeModal();
      this.$router.push({ name: "edit-client", params: { id: id } });
    },
    deleteClient(clientId) {
      if (!confirm("Delete this client? This cannot be undone.")) return;
      this.openKebabId = null;
      this.showLoading();
      this.$store
        .dispatch("client/deleteClient", { client_id: clientId })
        .then((res) => {
          if (res.status == 1) {
            this.$toast.success("Delete data Successful.");
            this.getClientData();
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    toggleKebab(id) {
      this.openKebabId = this.openKebabId === id ? null : id;
    },
    toggleSort() {
      this.sortDir = this.sortDir === "asc" ? "desc" : "asc";
      this.filterClients();
    },
    clientExists(clientID) {
      return clientID.id === this.client;
    },
    handleCloseAddItem() {
      this.$refs.itemListOnlyComponent.resetData();
      this.dialogVisibleItemsPopup = false;
    },
    runMountedFunctions() {
      this.fetchCurrency();
      this.getInvoiceNumber();
      this.getTaxDetails();
      this.fetchPaymentMethod();
      this.getTerms();
    },
    fullyPaidToggle() {
      // console.log(this.mark_fully_paid);

      if (this.mark_fully_paid) {
        this.pay_now_amount = this.outstanding_due;
      } else {
        this.pay_now_amount = 0;
      }
    },
    filterClients() {
      if (!this.searchQuery) {
        this.filteredClients = [...this.client_server_data]; // Important: Create a copy
      } else {
        const searchTerm = this.searchQuery.toLowerCase();
        this.filteredClients = this.client_server_data.filter((client) => {
          return (
            (client.full_name || "").toLowerCase().includes(searchTerm) ||
            (client.business_name || "").toLowerCase().includes(searchTerm) ||
            (client.email || "").toLowerCase().includes(searchTerm)
          );
        });
      }
      this.filteredClients.sort((a, b) => {
        const cmp = String(a.business_name ?? "").localeCompare(String(b.business_name ?? ""));
        return this.sortDir === "asc" ? cmp : -cmp;
      });
    },
    itemHandlePageChange(newPage) {
      this.itemCurrentPage = newPage;
    },
    clientHandlePageChange(newPage) {
      this.clientCurrentPage = newPage;
    },
    onClientCreated(createdClient) {
      this.showAddClientForm = false;
      this.getClientData();
      this.selectClient(createdClient);
    },
    selectClient(client) {
      console.log(client);

      this.client = client.id;
      this.clientName = client.full_name;
      const bootstrapModal = document.getElementById("getClient");
      if (bootstrapModal) {
        const bsModalInstance = Modal.getInstance(bootstrapModal);
        if (bsModalInstance) {
          bsModalInstance.hide();
        }
      }
    },
    closeItem() {
      const bootstrapModal = document.getElementById("addItemToList");
      if (bootstrapModal) {
        const bsModalInstance = Modal.getInstance(bootstrapModal);
        if (bsModalInstance) {
          bsModalInstance.hide();
        }
      }
    },
    getTerms() {
      this.showLoading();
      this.$store
        .dispatch("setting/getTermsDetails")
        .then((res) => {
          if (res.data.status == 1) {
            this.terms = res.data.response.invoice_days
              ? res.data.response.invoice_days
              : 30;
          } else {
            // throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    getInvoiceItems() {
      const selectedItems = this.$store.getters["item/getSelectedItemsList"];

      // Map through the selected items to transform them
      const transformedItems = selectedItems.map((item) => {
        const { name, unit_price, description, quantity, type } = item;

        // Calculate the total by multiplying quantity and unit_price
        const total = parseFloat(unit_price) * parseFloat(quantity);

        // Return a new object with required keys and the calculated total
        return {
          name,
          unit_price,
          description,
          quantity,
          type,
          total, // Add the calculated total to the object
        };
      });
      return transformedItems;
    },
    validateInvoice() {
      const errors = [];

      // Common required fields
      if (!this.invoice_status) errors.push("Invoice status is required.");
      if (!this.invoiceNumber) errors.push("Invoice number is required.");
      if (!this.client) errors.push("Client is required.");
      if (!this.terms) errors.push("Validity term is required.");
      if (!this.currency_id) errors.push("Currency is required.");

      // Additional required fields for non-draft statuses
      if (this.invoice_status !== "draft") {
        if (!this.invoice_date) errors.push("Invoice date is required.");
        if (!this.totalPrice) errors.push("Total Gross Amount is required.");
        // if (!this.subTotalPrice) errors.push("Total Net Amount is required.");
        // if (!this.total_amount_paid) errors.push("Total Paid Amount is required.");
        if (this.tax_1_rate === undefined || this.tax_1_rate === null) {
          errors.push("VAT percent is required.");
        }
      }

      // Show errors if any
      if (errors.length > 0) {
        errors.forEach((error) => this.$toast.error(error));
        return false;
      }

      return true;
    },
    saveInvoice() {
      if (!this.validateInvoice()) {
        return; // Stop if validation fails
      }
      const data = {
        total_amount_gross: this.totalPrice,
        invoice_status: this.invoice_status,
        invoice_type: this.invoice_type,
        invoice_date: this.invoice_date,
        invoice_number: this.invoiceNumber,
        client_id: this.client,
        validity_term: this.terms,
        currency_id: this.currency_id,
        payment: this.payment,
        remaining_due: this.outstanding_due,
        notes: this.note,
        invoice_items: this.getInvoiceItems(),
        vat_percent: this.tax_1_rate,
        vat_name: this.tax_1_name,
        tax1_percent: this.tax_2_rate,
        tax1_name: this.tax_2_name,
        vat_amount: this.vatTax,
        tax1_amount: this.vatTax2,
        is_image: this.image_list.length > 0 ? "Y" : "N",
        sub_total: this.subTotalPrice,
        total_discount_amount: Number(this.discountTypeValue).toFixed(2),
        discount_value: Number(this.discount).toFixed(2),
        discount_type: this.isPercentChecked ? "percent" : "amount",
        total_amount_paid: this.totalSubmittedAmount,
        total_amount_net: this.GrandTotal,
      };

      this.$store
        .dispatch("invoice/saveInvoice", data)
        .then((res) => {
          if (res.data.status == 1) {
            // localStorage.setItem("invoice-details", JSON.stringify(res.data.response));
            if (this.image_list.length > 0) {
              this.saveInvoiceAttachment(res.data.response.id);
            } else {
              this.$router.push({
                name: "show-invoice",
                params: { id: this.invoiceNumber },
                query: { from: "create" },
              });
            }
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => { });
    },
    saveInvoiceAttachment(id) {
      // Create a new FormData object
      const form_data = new FormData();

      // Append the invoice_id to FormData
      form_data.append("invoice_id", id);

      // Append each file to FormData with the key "invoice_attachments[]"
      this.image_list.forEach((image) => {
        form_data.append("invoice_attachments[]", image.file);
      });

      this.$store
        .dispatch("invoice/saveInvoiceAttachment", form_data)
        .then((res) => {
          if (res.data.status == 1) {
            this.$router.push({
              name: "show-invoice",
              params: { id: this.invoiceNumber },
              query: { from: "create" },
            });
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => { });
    },
    changeCurrency() {
      this.currency_symbol = this.currency.find(
        (currency) => currency.id === this.form.currency_id
      ).symbol;
    },
    async fetchCurrency() {
      this.currency = await this.axios
        .get(CURRENCY_LIST)
        .then(function (res) {
          return res.data.response;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async fetchPaymentMethod() {
      this.payment_method_list = await this.$store
        .dispatch("expenses/getPaymentOptions")
        .then((res) => {
          // console.log(res);
          if (res.status == 1) {
            return res.response;
            // this.$router.push({ name: 'user-dashboard' });
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => { });
    },
    getTaxDetails() {
      this.$store
        .dispatch("setting/getTaxDetails")
        .then((res) => {
          if (res.data.status == 1 && res.data.response != null) {
            this.tax_1_rate = res.data.response.tax1_rate;
            this.tax_1_name = res.data.response.tax1_name;
            this.tax_1_status_enable = res.data.response.is_tax1_enable;
            this.tax_2_rate = res.data.response.tax2_rate;
            this.tax_2_name = res.data.response.tax2_name;
            this.tax_2_status_enable = res.data.response.is_tax2_enable;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error("Something went wrong. Please try again.");
        });
    },
    handleCheckboxChange(type) {
      if (type === "percent") {
        this.isPercentChecked = true;
        this.isCashChecked = false;
      } else {
        this.isPercentChecked = false;
        this.isCashChecked = true;
      }
    },
    removeNewImage(index) {
      this.$confirm("Are you sure you want to remove this attachment?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          this.image_list.splice(index, 1);
          this.$toast.success("Attachment removed.");
        })
        .catch(() => { });
    },
    showLoading() {
      this.loadingInstance = this.$loading({
        lock: true,
        text: "Loading",
        background: "rgba(0, 0, 0, 0.7)",
        fullscreen: true,
      });
    },
    hideLoading() {
      this.loadingInstance.close();
    },
    filterExpenses() {
      console.log(this.search);
    },
    showItemListPopup() {
      this.dialogVisibleItemsPopup = true;
    },
    removeItem(item_no) {
      this.$store.commit("item/removeFromRecentItemsInvoice", item_no);
    },
    getClientData() {
      this.showLoading();
      this.$store
        .dispatch("client/getListByUser", this.form)
        .then((res) => {
          if (res.status == 1) {
            this.client_server_data = res.response;
            // this.$toast.success("Fetch data Successful.");
            // this.$router.push({ name: 'user-dashboard' });
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          this.client_server_data = [];
          // this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    getInvoiceNumber() {
      this.showLoading();
      this.$store
        .dispatch("invoice/getInvoiceNumber")
        .then((res) => {
          if (res.data.status == 1) {
            this.invoiceNumber = res.data.response.response;
            console.loog(res);
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          if (err.response && err.response.status === 404) {
            this.$toast.error("Resource not found");
          }
          // this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    onFileChange(e) {
      const files = Array.from(e.target.files);
      const maxSize = 512 * 1024; // 512 KB

      const processFile = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);

          reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;

            img.onload = () => {
              const canvas = document.createElement("canvas");
              const ctx = canvas.getContext("2d");

              // Resize logic: keep aspect ratio, max width/height 1024px (adjust if needed)
              const maxDimension = 1024;
              let { width, height } = img;
              if (width > height) {
                if (width > maxDimension) {
                  height *= maxDimension / width;
                  width = maxDimension;
                }
              } else {
                if (height > maxDimension) {
                  width *= maxDimension / height;
                  height = maxDimension;
                }
              }

              canvas.width = width;
              canvas.height = height;
              ctx.drawImage(img, 0, 0, width, height);

              // Compress to roughly 512 KB
              const qualityStep = 0.05;
              let quality = 0.9;

              const compress = () => {
                canvas.toBlob(
                  (blob) => {
                    if (blob.size > maxSize && quality > 0.1) {
                      quality -= qualityStep;
                      compress();
                    } else {
                      resolve({
                        file: new File([blob], file.name, { type: blob.type }),
                        url: URL.createObjectURL(blob),
                      });
                    }
                  },
                  "image/jpeg",
                  quality
                );
              };

              compress();
            };

            img.onerror = (err) => reject(err);
          };

          reader.onerror = (err) => reject(err);
        });
      };

      // Process all files
      Promise.all(files.map(processFile))
        .then((processedFiles) => {
          this.image_list = processedFiles;
          this.image_count = processedFiles.length;
          this.is_image = processedFiles.length ? "Y" : "N";
        })
        .catch((err) => {
          console.error("Error processing images:", err);
          this.$toast.error("Error processing images.");
          e.target.value = null;
        });
    },

    addPayment() {
      if (!this.payment_date) {
        this.$toast.error("Payment date is required");
        return false;
      }

      if (!this.payment_method) {
        this.$toast.error("Payment method is required");
        return false;
      }

      // if (!this.pay_now_description) {
      //   this.$toast.error("Description is required");
      //   return false;
      // }

      // Create a payment object based on the input values
      const newPayment = {
        submitted_amount: parseFloat(this.pay_now_amount).toFixed(2),
        submission_date: this.payment_date,
        amount: parseFloat(this.outstanding_due).toFixed(2),
        status:
          parseFloat(this.pay_now_amount) >= parseFloat(this.outstanding_due)
            ? "fully_paid"
            : "partially_paid",
        method: this.payment_method,
        description: this.pay_now_description,
      };

      this.invoice_status = "partpaid";
      this.invoice_type = "partpaid";

      if (this.pay_now_amount >= this.outstanding_due) {
        this.invoice_status = "paid";
        this.invoice_type = "paid";
      }

      // Push the newPayment object into the payment array
      this.payment.push(newPayment);

      const today = new Date();
      const formattedToday = today.toISOString().split("T")[0];
      // Clear the input fields or perform any other necessary actions after adding the payment
      this.pay_now_amount = 0;
      this.payment_date = formattedToday;
      this.outstanding_due = "";
      this.payment_method = "";
      this.pay_now_description = "";

      let selectedItems = this.$store.getters["item/getSelectedItemsList"] || [];
      let total_price = selectedItems.reduce((total, item) => {
        const itemPrice = parseInt(item.quantity) * parseFloat(item.unit_price);
        return total + itemPrice;
      }, 0);

      let discountedTotal = 0;
      if (this.isPercentChecked) {
        discountedTotal = total_price - (total_price * this.discount) / 100;
        this.discountTypeValue = (total_price * this.discount) / 100;
      } else {
        discountedTotal = total_price - this.discount;
        this.discountTypeValue = this.discount;
      }

      this.discountTypeValue = this.discount;

      const paymentAmountSum = this.payment
        .reduce((total, item) => total + parseFloat(item.submitted_amount), 0)
        .toFixed(2);

      let tax1Amount = 0;
      let tax2Amount = 0;

      if (this.tax_1_rate > 0) {
        tax1Amount = (this.subTotalPrice * this.tax_1_rate) / 100;
      }

      if (this.tax_2_rate > 0) {
        tax2Amount = (this.subTotalPrice * this.tax_2_rate) / 100;
      }

      this.outstanding_due = discountedTotal + tax2Amount + tax1Amount;

      this.outstanding_due = this.outstanding_due - paymentAmountSum;

      this.outstanding_due = this.outstanding_due.toFixed(2);
    },
  },
};
</script>

<style scoped>
.el-carousel {
  border: 2px solid #ccc;
  padding: 10px;
}

.preview {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border: 2px solid #fff;
}

.thumb-item {
  position: relative;
  display: inline-block;
}

.btn-delete-thumb {
  position: absolute;
  bottom: -5px;
  right: -5px;
  background: #ff4d4f;
  color: white;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.btn-delete-thumb:hover {
  background: #ff7875;
}
</style>
